import React from 'react';
import { Box, Typography, Button, Grid, Paper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from 'react-router-dom';
import exploreMainImg from './images/explore_main.png';
import mapToolBarImg from './images/map_tool_bar.png';

const ExplorePageDoc = () => {
  const history = useHistory();

  const steps = [
    {
      title: 'Navigating to the Explore Page',
      intro: 'The Explore Page is the central hub of interaction after login.',
      points: [
        '• After successful login, users are automatically redirected to the Explore Page.',
        '• The page offers a full-screen interactive map view by default.',
        '• Navigation tabs for Orders, Products, Notifications, and Profile are available at the top.'
      ],
      image: exploreMainImg
    },
    {
      title: 'Using the Map Toolbar (Left Panel)',
      intro: 'The left-side vertical toolbar provides powerful geospatial tools.',
      points: [
        '• Change map base layers between Satellite and Street view.',
        '• Measure distances by drawing straight lines on the map.',
        '• Draw a custom AOI (Area of Interest) using rectangle or polygon tools.',
        '• Upload external AOIs in GeoJSON format if pre-defined.',
        '• Zoom in and zoom out easily to adjust view for your area.'
      ],
      image: '/images/map_toolbar.png'
    },
    {
      title: 'Understanding the Floating Panel (Right Side)',
      intro: 'Quick access to Catalog Search, Tasking Requests, and Saved AOIs.',
      points: [
        '• "Catalog" Tab: Search and order existing archive imagery.',
        '• "Task" Tab: Task satellites for new future imagery acquisitions.',
        '• "Saved AOIs" Tab: Manage, edit, or re-use your previously saved areas.',
        '• Tabs float neatly and are collapsible for maximizing map view.'
      ],
      image: '/images/floating_panel.png'
    },
    {
      title: 'Drawing or Uploading an AOI',
      intro: 'Defining the AOI is essential for both catalog searches and tasking requests.',
      points: [
        '• Use the draw tool to manually sketch a rectangle or polygon on the map.',
        '• Double-click to finish drawing and automatically register the AOI.',
        '• Use the upload feature to add complex AOIs from existing GeoJSON files.',
        '• Confirm that the AOI is accurate to optimize search results and pricing.'
      ],
      image: '/images/draw_upload_aoi.png'
    },
    {
      title: 'Switching Between Map Views',
      intro: 'Enhance visibility based on context: urban features or satellite texture.',
      points: [
        '• Street View: Best for visualizing roads, city layouts, and landmarks.',
        '• Satellite View: Ideal for understanding terrain, vegetation, and rural areas.',
        '• Switching layers instantly updates your map without affecting the drawn AOIs.'
      ],
      image: '/images/map_layers.png'
    }
  ];

  return (
    <Box sx={{ maxWidth: '1000px', mx: 'auto', p: 4 }}>
      <Button startIcon={<ArrowBackIcon />} sx={{ mb: 4, color: '#1976d2' }} onClick={() => history.push("/documentation")}>
        Back to Documentation
      </Button>

      <Typography variant="h4" sx={{ mb: 4, fontWeight: 'bold', color: '#1976d2' }}>
        Explore Page - Navigating and Using the Map Tools
      </Typography>

      {steps.map((step, index) => (
        <Paper elevation={3} sx={{ p: 3, mb: 4, borderRadius: 2 }} key={index}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} md={6}>
              <Typography variant="h6" sx={{ mb: 2, color: '#333', fontWeight: 600 }}>{`${index + 1}. ${step.title}`}</Typography>
              <Typography variant="body1" color="text.secondary" sx={{ mb: 2 }}>{step.intro}</Typography>
              {step.points.map((point, idx) => (
                <Typography key={idx} variant="body2" color="text.secondary" sx={{ ml: 2, mb: 1 }}>{point}</Typography>
              ))}
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                component="img"
                src={step.image}
                alt={step.title}
                sx={{ width: '100%', height: 'auto', borderRadius: 2, boxShadow: 3 }}
              />
            </Grid>
          </Grid>
        </Paper>
      ))}
    </Box>
  );
};

export default ExplorePageDoc;